<div class="qc-dialog-shell">
  <div class="qc-dialog-header">
    <div class="qc-dialog-title-group">
      <div class="qc-dialog-title">Quality Control</div>
      <div class="qc-dialog-meta-grid">
        <div class="qc-dialog-meta-item">
          <span class="qc-dialog-meta-label">Game</span>
          <span class="qc-dialog-meta-value">{{ gameLabel }}</span>
        </div>
        <div class="qc-dialog-meta-item">
          <span class="qc-dialog-meta-label">Collector</span>
          <span class="qc-dialog-meta-value">{{ collectorLabel }}</span>
        </div>
        <div class="qc-dialog-meta-item">
          <span class="qc-dialog-meta-label">Event Type</span>
          <span class="qc-dialog-meta-value">{{ eventTypeLabel }}</span>
        </div>
      </div>
    </div>

    <button
      mat-icon-button
      type="button"
      aria-label="Close QC dialog"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="qc-dialog-content">
    <app-qc-expanded-panel
      [event]="data.event"
      (qcSaved)="onQcSaved($event)"
    ></app-qc-expanded-panel>
  </div>
</div>
